module.exports = __webpack_public_path__ + "img/b_02.c9bf9dd5.png";